import { render, staticRenderFns } from "./ChallengeQuest.vue?vue&type=template&id=7422d188"
import script from "./ChallengeQuest.vue?vue&type=script&lang=js"
export * from "./ChallengeQuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports